import { render, staticRenderFns } from "./Javascript.vue?vue&type=template&id=2cb470b0&"
import script from "./Javascript.vue?vue&type=script&lang=js&"
export * from "./Javascript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports